import { Menu, MenuItem } from '@material-ui/core';
import React from 'react';

type ActionsMenuProps = {
  anchorEl: null | HTMLElement;
  closeMenu: () => void;
  handleModal: () => void;
};

export const ActionsMenu = ({ anchorEl, closeMenu, handleModal }: ActionsMenuProps) => {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
      <MenuItem id='edit-plan-button' onClick={handleModal}>
        Editar comissões
      </MenuItem>
    </Menu>
  );
};
